<template>
    <div class="ld">
        <div class="lock-designer-layout">
            <div class="image-container" :style="`background-color: ${dominantColor}`">
                <div class="lock-designer-image-wrap">
	                <CustomZoomViewer class="lock-designer-image" :imageSrc="imageUrl" />
                </div>
            </div>
            <slot name="routerWrap"></slot>

	        <LoadIndicator :loadingResults="$store?.state?.isLoading" :useTransition="true"></LoadIndicator>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'; // Import useStore from vuex
import LockDesignerPanel from 'Vue/components/lockDesigner/components/LockDesignerPanel.vue';
import CustomZoomViewer from 'Vue/components/lockDesigner/components/CustomZoomViewer.vue';
import LoadIndicator from 'Vue/components/shared/LoadIndicator.vue';
import { FastAverageColor } from 'fast-average-color';
import InnerImageZoom from 'vue-inner-image-zoom';

interface CustomWindow extends Window {
    gtmTrack: any; // Adjust the type accordingly
}

declare let window: CustomWindow;

export default {
    name: 'LockDesigner',
    computed: {
        ...mapGetters(['imageUrl']),
    },
    data() {
        return {
            dominantColor: '' // Initialize dominantColor property
        };
    },
    components: {
        LockDesignerPanel,
	    LoadIndicator,
	    CustomZoomViewer
    },
    methods: {
        hexToRgb(hex) {
            // Remove the leading #
            hex = hex.replace(/^#/, '');

            // Parse the components
            const r = parseInt(hex.substring(0, 2), 16);
            const g = parseInt(hex.substring(2, 4), 16);
            const b = parseInt(hex.substring(4, 6), 16);

            // Return the RGB color
            return `${r}, ${g}, ${b}`;
        }
    },
    watch: {
        '$store.state': {
            handler(newState) {
                // Update the data attribute with the new state as JSON
                window.gtmTrack = newState;
            },
            deep: true, // Enable deep watching for nested properties
        },
        imageUrl(newValue) {
            // Alert out the imageUrl
            const fac = new FastAverageColor();

            fac.getColorAsync(newValue)
                .then(color => {
                    this.dominantColor = color.hex;
                    let rgbVal = this.hexToRgb(color.hex);
                    document.documentElement.style.setProperty('--dominant-color', rgbVal);
                })
                .catch(e => {
                    console.log(e);
                });
        }
    }
};
</script>
